// Remove a máscara e normaliza para maiúsculas, preservando letras do CNPJ alfanumérico.
const stripDocument = (value) => String(value || '').replace(/[^0-9A-Za-z]/g, '').toUpperCase();

// Valida o CNPJ alfanumérico (12 posições base [A-Z0-9] + 2 dígitos verificadores numéricos).
// DV via módulo 11 usando o valor de cada caractere = charCode - 48 ('0'->0 ... 'A'->17).
// Espelha helpers/util.js do backend para frontend e backend concordarem sobre validade.
const isValidCnpj = (raw) => {
  const cnpj = stripDocument(raw);
  if (cnpj.length !== 14) return false;
  if (/^(.)\1{13}$/.test(cnpj)) return false; // rejeita repetição total
  if (!/^[0-9A-Z]{12}[0-9]{2}$/.test(cnpj)) return false; // 12 alfanum + 2 DV numérico

  const charValue = (ch) => ch.charCodeAt(0) - 48;
  const calcDigit = (len) => {
    const pesos = len === 12
      ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
      : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let soma = 0;
    for (let i = 0; i < len; i++) {
      soma += charValue(cnpj[i]) * pesos[i];
    }
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  };

  return calcDigit(12) === Number(cnpj[12]) && calcDigit(13) === Number(cnpj[13]);
};

export { stripDocument, isValidCnpj };
